import { call, put } from 'redux-saga/effects';
import GetAppointmentCategoriesActions from '../redux/GetAppointmentCategoriesRedux';
import { api } from './api';


export function* getAppointmentCategories(action: any): Generator<any, void, any> {
  const { data } = action;
  const response = yield call(api.getAppointmentCategories, data);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetAppointmentCategoriesActions.getAppointmentCategoriesSuccess(response.data.data));
  } else {
    yield put(GetAppointmentCategoriesActions.getAppointmentCategoriesFailure());
  }
}